import { render, staticRenderFns } from "./register-form1.vue?vue&type=template&id=15c8e546&scoped=true&"
import script from "./register-form1.vue?vue&type=script&lang=ts&"
export * from "./register-form1.vue?vue&type=script&lang=ts&"
import style0 from "./register-form1.vue?vue&type=style&index=0&id=15c8e546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c8e546",
  null
  
)

export default component.exports